import { useEditorState } from '@tiptap/react'
import { BubbleMenu as TiptapBubbleMenu } from '@tiptap/react/menus'

import BoldOutlined from '@ant-design/icons/BoldOutlined'
import HighlightOutlined from '@ant-design/icons/HighlightOutlined'
import ItalicOutlined from '@ant-design/icons/ItalicOutlined'
import UnderlineOutlined from '@ant-design/icons/UnderlineOutlined'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import { useTheme } from '@mui/material/styles'

import { Icon, LinkButton, surface } from './Toolbar'

export default function BubbleMenu({ editor }) {
  const theme = useTheme()
  const state = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isBold: editor.isActive('bold'),
      isItalic: editor.isActive('italic'),
      isUnderline: editor.isActive('underline'),
      isHighlight: editor.isActive('highlight'),
    }),
  })

  return (
    <TiptapBubbleMenu editor={editor} style={{ zIndex: theme.zIndex.tooltip }}>
      <Box sx={[surface, { p: 0.5 }]}>
        <Icon title="Bold" isActive={state.isBold} onClick={() => editor.chain().focus().toggleBold().run()}>
          <BoldOutlined />
        </Icon>
        <Icon title="Italic" isActive={state.isItalic} onClick={() => editor.chain().focus().toggleItalic().run()}>
          <ItalicOutlined />
        </Icon>
        <Icon title="Underline" isActive={state.isUnderline} onClick={() => editor.chain().focus().toggleUnderline().run()}>
          <UnderlineOutlined />
        </Icon>
        <Icon title="Highlight" isActive={state.isHighlight} onClick={() => editor.chain().focus().toggleHighlight().run()}>
          <HighlightOutlined />
        </Icon>
        <Divider orientation="vertical" flexItem />
        <LinkButton editor={editor} />
      </Box>
    </TiptapBubbleMenu>
  )
}
